<div [@routerTransition] class="d-flex flex-column flex-root">
    <div class="page d-flex flex-row flex-column-fluid">
        <div
            id="kt_aside"
            class="aside"
            data-kt-drawer="true"
            data-kt-drawer-name="aside"
            data-kt-drawer-activate="{default: true, lg: false}"
            data-kt-drawer-overlay="true"
            data-kt-drawer-width="{default:'200px', '300px': '250px'}"
            data-kt-drawer-direction="start"
            data-kt-drawer-toggle="#kt_aside_mobile_toggle"
        >
            <div class="aside-menu flex-column-fluid">
                <side-bar-menu
                    [menuClass]="
                        'menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500'
                    "
                ></side-bar-menu>
            </div>
        </div>
        <div class="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
            <div id="kt_header" class="header align-items-stretch">
                <div class="header-brand">
                    <theme8-brand></theme8-brand>
                    <div
                        id="kt_aside_toggle"
                        class="btn btn-icon w-auto px-0 btn-active-color-primary aside-minimize"
                        data-kt-toggle="true"
                        data-kt-toggle-state="active"
                        data-kt-toggle-target="body"
                        data-kt-toggle-name="aside-minimize"
                    >
                        <span class="svg-icon svg-icon-1 me-n1 minimize-default">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    opacity="0.3"
                                    x="8.5"
                                    y="11"
                                    width="12"
                                    height="2"
                                    rx="1"
                                    fill="currentColor"
                                ></rect>
                                <path
                                    d="M10.3687 11.6927L12.1244 10.2297C12.5946 9.83785 12.6268 9.12683 12.194 8.69401C11.8043 8.3043 11.1784 8.28591 10.7664 8.65206L7.84084 11.2526C7.39332 11.6504 7.39332 12.3496 7.84084 12.7474L10.7664 15.3479C11.1784 15.7141 11.8043 15.6957 12.194 15.306C12.6268 14.8732 12.5946 14.1621 12.1244 13.7703L10.3687 12.3073C10.1768 12.1474 10.1768 11.8526 10.3687 11.6927Z"
                                    fill="currentColor"
                                ></path>
                                <path
                                    opacity="0.5"
                                    d="M16 5V6C16 6.55228 15.5523 7 15 7C14.4477 7 14 6.55228 14 6C14 5.44772 13.5523 5 13 5H6C5.44771 5 5 5.44772 5 6V18C5 18.5523 5.44771 19 6 19H13C13.5523 19 14 18.5523 14 18C14 17.4477 14.4477 17 15 17C15.5523 17 16 17.4477 16 18V19C16 20.1046 15.1046 21 14 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H14C15.1046 3 16 3.89543 16 5Z"
                                    fill="currentColor"
                                ></path>
                            </svg>
                        </span>
                        <span class="svg-icon svg-icon-1 minimize-active">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    opacity="0.3"
                                    width="12"
                                    height="2"
                                    rx="1"
                                    transform="matrix(-1 0 0 1 15.5 11)"
                                    fill="currentColor"
                                ></rect>
                                <path
                                    d="M13.6313 11.6927L11.8756 10.2297C11.4054 9.83785 11.3732 9.12683 11.806 8.69401C12.1957 8.3043 12.8216 8.28591 13.2336 8.65206L16.1592 11.2526C16.6067 11.6504 16.6067 12.3496 16.1592 12.7474L13.2336 15.3479C12.8216 15.7141 12.1957 15.6957 11.806 15.306C11.3732 14.8732 11.4054 14.1621 11.8756 13.7703L13.6313 12.3073C13.8232 12.1474 13.8232 11.8526 13.6313 11.6927Z"
                                    fill="currentColor"
                                ></path>
                                <path
                                    d="M8 5V6C8 6.55228 8.44772 7 9 7C9.55228 7 10 6.55228 10 6C10 5.44772 10.4477 5 11 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H11C10.4477 19 10 18.5523 10 18C10 17.4477 9.55228 17 9 17C8.44772 17 8 17.4477 8 18V19C8 20.1046 8.89543 21 10 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H10C8.89543 3 8 3.89543 8 5Z"
                                    fill="currentColor"
                                ></path>
                            </svg>
                        </span>
                    </div>
                    <div class="d-flex align-items-center d-lg-none ms-n3 me-1" title="Show aside menu">
                        <div class="btn btn-icon btn-active-color-primary w-30px h-30px" id="kt_aside_mobile_toggle">
                            <span class="svg-icon svg-icon-1">
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z"
                                        fill="currentColor"
                                    ></path>
                                    <path
                                        opacity="0.3"
                                        d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z"
                                        fill="currentColor"
                                    ></path>
                                </svg>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="toolbar">
                    <div
                        [class]="
                            containerClass +
                            ' py-6 py-lg-0 d-flex flex-column flex-lg-row align-items-lg-stretch justify-content-end'
                        "
                    >
                        <div class="d-flex align-items-center pt-3 pt-lg-0 justify-content-end">
                            <subscription-notification-bar
                                [customStyle]="
                                    'btn btn-relative btn-sm btn-icon btn-icon-muted btn-active-icon-primary position-relative'
                                "
                            ></subscription-notification-bar>
                            <quick-theme-selection
                                [customStyle]="
                                    'btn btn-relative btn-sm btn-icon btn-icon-muted btn-active-icon-primary position-relative'
                                "
                            ></quick-theme-selection>
                            <language-switch-dropdown
                                [customStyle]="
                                    'btn btn-relative btn-sm btn-icon btn-icon-muted btn-active-icon-primary position-relative'
                                "
                            ></language-switch-dropdown>
                            <header-notifications
                                [customStyle]="
                                    'btn btn-relative btn-sm btn-icon btn-icon-muted btn-active-icon-primary position-relative'
                                "
                            ></header-notifications>
                            <chat-toggle-button
                                [customStyle]="
                                    'btn btn-relative btn-sm btn-icon btn-icon-muted btn-active-icon-primary position-relative'
                                "
                            ></chat-toggle-button>

                            <toggle-dark-mode
                                [customStyle]="
                                    'btn btn-relative btn-sm btn-icon btn-icon-muted btn-active-icon-primary position-relative'
                                "
                                [isDarkModeActive]="isDarkModeActive()"
                            ></toggle-dark-mode>

                            <user-menu [togglerCssClass]="'symbol symbol-50px cursor-pointer'"></user-menu>
                        </div>
                    </div>
                </div>
            </div>
            <router-outlet></router-outlet>

            <footer-bar></footer-bar>
        </div>
    </div>
</div>
